import { NAME_SPACE } from './config';
import vimeoPlayer from './VimeoComponent.vue';

export default {
    name: NAME_SPACE,
    components: {
        'vimeo-component': vimeoPlayer,
    },
};
